export const GET_INPUT_HANDLE = "GET_INPUT_HANDLE";
export const GET_UNIT_NAME = "GET_UNIT_NAME";
export const GET_CATEGORY_NAME = "GET_CATEGORY_NAME";
export const GET_CUSTOMER_GROUP = "GET_CUSTOMER_GROUP";
export const GET_DASHBOARD_DATA = "GET_DASHBOARD_DATA";
export const GET_AFML_DASHBOARD_DATA = "GET_AFML_DASHBOARD_DATA";
export const CHANGE_PRODUCT_INPUT = "CHANGE_PRODUCT_INPUT";
export const INSERT_ACCOUNT_TARGET = "INSERT_ACCOUNT_TARGET";
export const CHANGE_PRODUCT_INPUT_REPORT = "CHANGE_PRODUCT_INPUT_REPORT";
export const CHANGE_HANDLE_DATE_MANAGE = "CHANGE_HANDLE_DATE_MANAGE";